import { render, staticRenderFns } from "./ProductPriceList.vue?vue&type=template&id=4e0b3624&scoped=true"
import script from "./ProductPriceList.vue?vue&type=script&lang=js"
export * from "./ProductPriceList.vue?vue&type=script&lang=js"
import style0 from "./ProductPriceList.vue?vue&type=style&index=0&id=4e0b3624&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0b3624",
  null
  
)

export default component.exports